import { gql } from '@apollo/client';

/** Every carrier in the org's onboarding view, with the flags that place it and its badges. */
export const GET_ORG_CARRIER_ONBOARDING = gql`
    query GetOrgCarrierOnboarding($organization_id: uuid!) {
        organization_carrier_statuses(where: { organization_id: { _eq: $organization_id } }) {
            organization_id
            carrier_id
            relationship
            logged_in
            pricing_set_up
            docs_complete
            compliance_status
            integration_status
            integrations_required
            last_invited_at
            in_account_setup
            in_compliance
            in_integrations
            is_live
            badge_invited
            badge_requested_documents
            badge_in_compliance
            badge_rejected
            badge_live
            badge_needs_pricing
            badge_no_integrations
            badge_approved
            badge_integration_not_live
            badge_account_info_needed
            setup_uploaded
            setup_invited
            setup_in_progress
            setup_awaiting_compliance
            compliance_awaiting_review
            compliance_approved
            compliance_denied
            integrations_awaiting_information
            integrations_in_progress
            integrations_live
            live_ready_to_link
            live_linked
            carrier {
                client_id
                business_name
                email
                user {
                    user_id
                    email
                }
            }
        }
    }
`;

/** Every shipper in the org's onboarding view, with the flags that place it. */
export const GET_ORG_SHIPPER_ONBOARDING = gql`
    query GetOrgShipperOnboarding($organization_id: uuid!) {
        organization_shipper_statuses(where: { organization_id: { _eq: $organization_id } }) {
            organization_id
            shipper_id
            integrations_required
            in_account_setup
            in_integrations
            is_live
            badge_no_integrations_setup
            badge_integration_failing
            badge_integration_needs_info
            badge_no_integrations
            badge_no_pricing
            badge_no_connected_carriers
            badge_carriers_missing_pricing
            badge_no_delivery_profile
            badge_no_orders
            badge_live
            shipper {
                client_id
                business_name
                email
                user {
                    user_id
                    email
                }
            }
        }
    }
`;
